import { ITripGroup } from '../types/trip.types';
import { findFirstPendingTripIndex, findNextPendingTrip } from '../services/trip.service';

export const areAllTripsResolved = (groups: ITripGroup[]): boolean => {
    if (groups.length === 0) return false;
    return groups.every(g => g.status === 'approved' || g.status === 'declined');
};

export const shouldTransitionToOverall = (groups: ITripGroup[]): boolean => {
    return areAllTripsResolved(groups);
};

export const getNextPendingTripIndex = (groups: ITripGroup[], currentIndex: number): number | null => {
    if (groups.length === 0) return null;
    const nextIndex = findNextPendingTrip(groups, currentIndex);
    return nextIndex !== null ? nextIndex : findFirstPendingTripIndex(groups);
};

export const getInitialNavigationState = (groups: ITripGroup[]): { viewType: 'trip' | 'overall'; selectedIndex: number } => {
    if (groups.length === 0) {
        return { viewType: 'trip', selectedIndex: 0 };
    }
    
    if (shouldTransitionToOverall(groups)) {
        return { viewType: 'overall', selectedIndex: 0 };
    }
    
    const firstPendingIndex = findFirstPendingTripIndex(groups);
    return {
        viewType: 'trip',
        selectedIndex: firstPendingIndex !== null ? firstPendingIndex : 0
    };
};

